module.exports = __webpack_public_path__ + "static/baileywithvampire-dbf73d1cb40871576980669f9a5592e3.jpg";